module.exports = __webpack_public_path__ + "build/assets/lmroman12-bold-8bbf3de15528376a2b1dfb4a8912c6fa.woff2";